import axios from './axiosService';

export default {
  getMyNotesForPresentation(presentationID) {
    const config = {
      params: {
        presentation_id: presentationID,
      }
    }
    return axios.get(`/api/user/presentation-notes`, config)
      .then(response => response.data);
  },
  deleteMyNotesForPresentation(presentationID) {
    return axios.delete(`/api/presentations/${presentationID}/notes`)
      .then(response => response.data);
  }
}
